// src/components/ui/DogProfileCard.jsx
import { motion } from "motion/react";
import ImageWithFallback from "./ImageWithFallback";

export default function DogProfileCard({
                                           dog,
                                           index,
                                           primaryColor,
                                           secondaryColor,
                                           styles,
                                           onClick,
                                       }) {
    const {
        name,
        imageSrc,
        sex = "Hündin",
        subtitle, // z.B. "Havaneser · chocolate"
        description,
        badges = [], // kurze Chips: ["Zuchthündin", "Gesundheitsgeprüft"]
        details = [], // Liste: [{ label:"Geboren", value:"2022" }, ...]
        highlights = [], // Bulletpoints
    } = dog;

    const badgeColor = sex === "Rüde" ? secondaryColor : primaryColor;

    return (
        <motion.article
            style={styles.dogCard}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: Math.min(index * 0.06, 0.3) }}
            viewport={{ once: true }}
            whileHover={{ y: -4 }}
            onClick={() => onClick?.(dog)}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={(e) => {
                if (!onClick) return;
                if (e.key === "Enter" || e.key === " ") onClick(dog);
            }}
        >
            <div style={styles.dogImageContainer}>
                <ImageWithFallback
                    src={imageSrc}
                    alt={name ?? "Hund"}
                    style={styles.dogImage}
                />

                <div style={{ ...styles.dogSexBadge, backgroundColor: badgeColor }}>
                    {sex}
                </div>

                {!!badges?.length && (
                    <div style={styles.dogBadgesRow}>
                        {badges.slice(0, 3).map((b, i) => (
                            <span key={`${b}-${i}`} style={styles.dogChip}>
                {b}
              </span>
                        ))}
                    </div>
                )}
            </div>

            <div style={styles.dogInfo}>
                <div style={styles.dogHeaderRow}>
                    <h3 style={{ ...styles.dogName, color: "#4A4A4A" }}>{name}</h3>
                </div>

                {subtitle && <div style={styles.dogSubtitle}>{subtitle}</div>}

                {description && <p style={styles.dogDescription}>{description}</p>}

                {!!details?.length && (
                    <div style={styles.dogDetails}>
                        {details.slice(0, 4).map((d, i) => (
                            <div key={`${d.label}-${i}`} style={styles.dogDetailRow}>
                                <span style={styles.dogDetailLabel}>{d.label}:</span>
                                <span style={styles.dogDetailValue}>{d.value}</span>
                            </div>
                        ))}
                    </div>
                )}

                {!!highlights?.length && (
                    <ul style={styles.dogHighlights}>
                        {highlights.slice(0, 3).map((h, i) => (
                            <li key={`${h}-${i}`}>{h}</li>
                        ))}
                    </ul>
                )}
            </div>
        </motion.article>
    );
}
